module.exports = __webpack_public_path__ + "img/image 7.a631d9d9.png";